var $f4ce49adf6ef095f$exports = {};
$f4ce49adf6ef095f$exports = {
    "dismiss": `Odbaci`
};


export {$f4ce49adf6ef095f$exports as default};
//# sourceMappingURL=sr-SP.mjs.map
